import React from 'react'
import ReactDOM from 'react-dom';
import {Layout, Form, Input, Button, message, Space, Popover, Row, Col, Modal, Radio, Statistic} from 'antd'
import {UserOutlined, LockOutlined, VerifiedOutlined, CheckCircleFilled, AndroidFilled} from '@ant-design/icons'
import {Redirect} from 'react-router'
import store from "../store/store.js";


const {Countdown} = Statistic;

class Formlogin extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            title: props.title,
            isLogin: store.getState().data.isLogin,
            yz: false,
            verifyimg: '/login/verify',
            visible: false,
            condition: {}
        }
    }

    componentDidMount() {
        let that = this
        that.getVerify()
    }

    onFinish(values) {
        // if (this.state.yz) {
        fetch('/Login/dologin', {
            // post提交
            method: "POST",
            body: JSON.stringify(values)
        })
            .then(res => res.json())
            .then(data => {

                if (data.status == 1) {
                    message.success(data.msg);
                    this.props.doLoginRedux.GOLOGIN(data.data, this.props.doLoginRedux.history);
                    this.setState({isLogin: store.getState().data.isLogin})
                } else {
                    message.error(data.msg);
                    this.getVerify()
                }
            })
        // } else {
        // 	message.error('请验证后登录');
        // }
    };

    success() {
        this.setState({
            yz: true
        })
    }

    islogin() {
        if (this.state.isLogin == true) {
            return <Redirect to={'/'}/>;
        }
    }

    getVerify = () => {
        let that = this
        that.setState({
            verifyimg: "/login/verify.html" + "?" + Math.random()
        })
    }

    sub() {
        let that = this
        that.setState({
            loading: true
        })
        fetch('/Login/doRegister', {
            method: "POST",
            body: JSON.stringify(that.state.condition)
        })
            .then(res => res.json())
            .then(data => {
                if (data.status == 1) {
                    message.success(data.msg);
                    setTimeout(() => {
                        window.location.replace("./Index/zhongbao")
                        that.setState({
                            loading: true
                        })
                    }, 1000)
                } else {
                    message.error(data.msg);
                    that.setState({
                        loading: false
                    })
                }
            })
    }

    render() {
        {
            this.islogin()
        }
        // console.log(this.props.appUrl, this.props.appstoreUrl);
        return (
            <>
                <div className="form">
                    <div className='head'>永泰园区运营系统</div>
                    <Form
                        name="normal_login"
                        className="login-form"
                        initialValues={{
                            type: 2
                        }}
                        onFinish={this.onFinish.bind(this)}
                    >
                        <Form.Item
                            name="username"
                            rules={[
                                {
                                    required: true,
                                    message: '请输入账号!',
                                },
                            ]}
                        >
                            <Input prefix={<UserOutlined className="site-form-item-icon"/>} placeholder="账号"
                                   className="input" autoComplete="off"/>
                        </Form.Item>
                        <Form.Item
                            name="password"
                            rules={[
                                {
                                    required: true,
                                    message: '请输入密码!',
                                },
                            ]}
                        >
                            <Input
                                prefix={<LockOutlined className="site-form-item-icon"/>}
                                type="password"
                                placeholder="密码"
                                className="input"
                                autoComplete="off"
                            />
                        </Form.Item>
                        <Form.Item
                            name="verify"
                            rules={[
                                {
                                    required: true,
                                    message: '请输入验证码!',
                                },
                            ]}
                        >
                            <Space style={{width: '100%'}}>
                                <Input prefix={<VerifiedOutlined className="site-form-item-icon"/>} placeholder="验证码"
                                       className="input" autoComplete="off" style={{width: '100%'}}/>
                                {/* <img src={this.state.verifyimg} onClick={this.getVerify.bind(this)} width="120"></img> */}
                                <img src={this.state.verifyimg} onClick={this.getVerify.bind(this)}
                                     style={{width: '100%', height: '60px'}}></img>
                            </Space>
                        </Form.Item>
                        <Form.Item>
                            <Button htmlType="submit" className="login-form-button" style={{fontSize: 18}}>
                                登 录
                            </Button>
                        </Form.Item>
                    </Form>
                </div>
            </>
        );
    }
};
export default class Login extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            title: '',
        };
        store.subscribe(() => {
            // console.log('state状态改变了，新状态如下')
            // console.log(store.getState().data)
        })
    }

    componentWillMount() {
        this.props.OUT_LOGIN();
    }


    render() {
        return (
            <div className="loginpost">
                <Formlogin doLoginRedux={this.props}/>
            </div>
        )
    }
}
